import React, { useState, useEffect } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import Grid from "@mui/material/Grid";
import InputControl from '../../Components/Common/TextField/TextField';
import CustomButton from '../../Components/Button/Button';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import Button from "@mui/material/Button";
import { useNavigate } from 'react-router-dom';
import './ManagePolicyContent.css';
import { GetAllPolicies, DeletePolicy } from "../../Reducers/dcoi";
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../Components/Common/Spinner/Spinner';
import Pagination from '@mui/material/Pagination';
import ConfirmationModel from '../../Components/Common/DeleteModel/DeleteModel';
import Toster from '../../Components/Common/Toster/Toster';
import CheckIcon from '@mui/icons-material/Check';


function ManagePolicyContentHome() {
  const dispatch = useDispatch();
  const { policiesList, inProgress } = useSelector(
    (state) => state.dcoi
  );
  const navigate = useNavigate();
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState();
  const [severity, setSavirity] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredItems, setFilteredItems] = useState(policiesList);
  const [deleteModel, setDeleteModel] = useState(false);
  const [itemID, setItemID] = useState()  // Store filtered items
  const itemsPerPage = 20;

  useEffect(() => {
    dispatch(GetAllPolicies());
  }, [dispatch]);

  useEffect(() => {
    if (policiesList?.length > 0) {
      setFilteredItems(policiesList); // Update filteredPolicies with the fetched data
    }
  }, [policiesList]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleSearchChange = (e) => {
    if (e !== undefined) {
      setSearchQuery(e);
    }
  };

  const handleSearchClick = () => {
    const filteredData = policiesList.filter(item =>
      item?.Title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item?.Language?.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredItems(filteredData); // Update the filtered items state
    setCurrentPage(1); // Reset pagination to the first page
  };

  // Pagination logic - Slice based on filteredItems
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const SucessDelete = () => {
    try {
      dispatch(DeletePolicy({ policyId: itemID })).then((res) => {
        if (res?.payload?.data[0]?.status === "done" && res?.payload?.status === 200) {
          setAlert(true);
          setSavirity("success");
          setMessage(res?.payload?.data[0]?.success)
          setDeleteModel(!deleteModel);
          dispatch(GetAllPolicies());
        } else if (res?.payload?.data[0]?.status === "error") {
          setAlert(true);
          setMessage(res?.payload?.data[0]?.error)
          setSavirity("error");
        } else {
          setAlert(true);
          setMessage("Something Went Wrong")
          setSavirity("error");
        }
      })
    } catch {
      setAlert(true);
      setSavirity("error");
      setMessage(`SomeThing Went Wrong..`)
    }

  }


  return (
    <>
      <Toster message={message} severity={severity} alert={alert} setAlert={setAlert} />
      <ConfirmationModel open={deleteModel} handleOpen={() => setDeleteModel(!deleteModel)} SucessDelete={SucessDelete} />
      <div className='headerNavigation'>
        <Typography sx={{ fontSize: "16px", fontWeight: "500" }}>List of Policy</Typography>
      </div>
      <Box className='boxAlignment'>
        <Grid container spacing={2} alignItems="center" justifyContent="space-between">
          <Grid item xs={12} sm={8} md={6}>
            <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
              <Box sx={{ flexGrow: 1 }}>
                <InputControl
                  type="text"
                  placeholder="Search by Policy Title or Language"
                  value={searchQuery}
                  onChange={handleSearchChange}
                />
              </Box>
              <Button
                sx={{ backgroundColor: " #212129", color: "white", padding: "8px", borderRadius: "0px" }}
                startIcon={<SearchIcon className="actionIcon" />}
                onClick={handleSearchClick} // Trigger search functionality on button click
              >
              </Button>
            </Box>
          </Grid>
          <Grid item>
            <CustomButton onClick={() => navigate(`/app-dcoi/sitecontent/ManagePolicyContent`)} label="+ ADD NEW POLICY" />
          </Grid>
        </Grid>
        <Box sx={{ margin: "20px", width: "100%", overflowX: "auto" }}>
          <Box sx={{ minWidth: "600px" }}>
            <Grid container spacing={2} my={2} alignItems="flex-start" sx={{ fontWeight: "bold", color: "gray" }}>
              <Grid item xs={3} sm={3} md={3}>TITLE</Grid>
              <Grid item xs={2} sm={2} md={2}>LANGUAGE</Grid>
              <Grid item xs={4} sm={4} md={4}>ENTITY ADMIN GROUP</Grid>
              <Grid item xs={1} sm={1} md={1}>IN USE</Grid>
              <Grid item xs={2} sm={2} md={2}></Grid>
            </Grid>
            <Divider />
            {filteredItems.length > 0 ? (
              currentItems.map((item, index) => (
                <React.Fragment key={index}>
                  <Grid container alignItems="flex-start" spacing={2} sx={{ alignItems: "center", padding: "10px 0px" }}>
                    {/* Title */}
                    <Grid item xs={3} sm={3} md={3}>
                      {/* <Typography sx={{ fontWeight: "bold", color: "gray", display: { xs: "block", md: "none" } }}>
                  TITLE
                </Typography> */}
                      <Typography>{item.Title}</Typography>
                    </Grid>

                    {/* Language */}
                    <Grid item xs={2} sm={2} md={2}>
                      {/* <Typography sx={{ fontWeight: "bold", color: "gray", display: { xs: "block", md: "none" } }}>
                  LANGUAGE
                </Typography> */}
                      <Typography>{item.Language}</Typography>
                    </Grid>

                    {/* Entity Admin Group */}
                    <Grid item xs={4} sm={4} md={4}>
                      {/* <Typography sx={{ fontWeight: "bold", color: "gray", display: { xs: "block", md: "none" } }}>
                  ENTITY ADMIN GROUP
                </Typography> */}
                      <Typography>{item.UserGroup}</Typography>
                    </Grid>

                    {/* In Use */}
                    <Grid item xs={1} sm={1} md={1}>
                      {/* <Typography sx={{ fontWeight: "bold", color: "gray", display: { xs: "block", md: "none" } }}>
                  IN USE
                </Typography> */}
                      <Typography>{item.InUse===1 && <CheckIcon color="success" />}</Typography>
                    </Grid>

                    {/* Actions - Desktop */}
                    <Grid
                      item
                      xs={12} sm={2} md={2}
                      sx={{ display: { xs: "none", sm: "none", md: "flex" }, justifyContent: "right", cursor: "pointer" }}
                    >
                      {item.InUse===0 && (
                        <Button
                          className='actionButton'
                          variant="contained"
                          startIcon={<DeleteIcon className='actionIcon' />}
                          onClick={() => {
                            setItemID(item.ID);
                            setDeleteModel(!deleteModel);
                          }}
                        >
                          Delete
                        </Button>
                      )}
                      &nbsp;&nbsp;
                      <Button
                        className='actionButton'
                        variant="contained"
                        startIcon={<EditIcon className='actionIcon' />}
                        onClick={() => navigate('/app-dcoi/sitecontent/ManagePolicyContent', { state: { policyData: item } })}
                      >
                        Edit
                      </Button>
                    </Grid>

                    {/* Actions - Mobile */}
                    <Grid
                      item
                      xs={2} sm={2} md={2}
                      sx={{ display: { xs: "flex", sm: "flex", md: "none" }, justifyContent: "right", cursor: "pointer" }}
                    >
                      {item.InUse===0  && (
                        <DeleteIcon
                          className='actionIconResponsive'
                          onClick={() => {
                            setItemID(item.ID);
                            setDeleteModel(!deleteModel);
                          }}
                        />
                      )}
                      &nbsp;&nbsp;
                      <EditIcon
                        className='actionIconResponsive'
                        onClick={() => navigate('/app-dcoi/sitecontent/ManagePolicyContent', { state: { policyData: item } })}
                      />
                    </Grid>
                  </Grid>
                  <Divider />
                </React.Fragment>
              ))

            ) : (
              <>
                {(!inProgress && currentItems?.length === 0) || policiesList?.length === 0 ? (
                  <Typography sx={{ margin: "20px", textAlign: "center", color: "gray", fontStyle: "italic" }}>
                    No Data Found...
                  </Typography>
                ) : ""}
              </>
            )}
          </Box>
        </Box>
        {filteredItems.length > 0 && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Pagination showFirstButton showLastButton sx={{
              margin: "10px", padding: "5px", border: "1px solid  #212129",
              borderRadius: "20px"
            }}
              count={Math.ceil(filteredItems.length / itemsPerPage)}
              page={currentPage}
              onChange={handlePageChange}
            /></Box>
        )}
      </Box>
      {/* <Grid container spacing={2} alignItems="center" justifyContent="center">
        <Grid item xs={12} sm={12} md={12} sx={{ margin: "20px", display: "flex", justifyContent: "center" }}>
          <CustomButton label="Save Policy " />
          &nbsp;&nbsp;
          <CustomButton label="Cancel" />
        </Grid>
      </Grid> */}
      <Spinner isLoading={inProgress} />
    </>
  );
}

export default ManagePolicyContentHome;
